<template>
  <div class="tw-p-6 sf-grid">
    <div class="sf-row sf-row-center">
      <div class="sf-col">
        <div class="sf-bg-white sf-layer-rounded sf-border-box">
          <inbox-search
            :placeholder="
              I18n.t('inbox.search_placeholder.company', {
                companyName: companyName,
              })
            "
            @search="handleSearch"
          ></inbox-search>
          <div
            class="sf-inbox tw-justify-center"
            style="height: calc(100vh - 266px)"
          >
            <div
              v-if="!loadingNotifications && notifications.length === 0"
              data-spec="notifications-loaded"
            >
              <template v-if="querySearch"
                ><empty-state
                  :text="I18n.t('inbox.empty_state.no_search_matches')"
                ></empty-state></template
              ><template v-else
                ><empty-state
                  :text="I18n.t('inbox.empty_state.no_messages_text')"
                  :title="I18n.t('inbox.empty_state.no_messages_title')"
                ></empty-state
              ></template>
            </div>
            <template v-else
              ><div class="sf-inbox-messages sf-pad-2">
                <div class="sf-layer-border sf-layer-white sf-overflow-hidden">
                  <div v-if="loadingNotifications">
                    <div class="sf-level sf-level-around sf-pad-3">
                      <div class="sf-spinner"></div>
                    </div>
                  </div>
                  <div v-else data-spec="notifications-loaded">
                    <notification-preview
                      v-for="preview in notifications"
                      :key="preview.id"
                      :is-active="preview.id === activeNotificationId"
                      v-bind="preview"
                      @click="handleClick"
                      @markUnread="handleMarkUnread"
                    ></notification-preview>
                  </div>
                </div>
              </div>
              <div class="sf-inbox-detail sf-inbox-detail-pulse">
                <notification-content
                  :communication-item="communicationItem"
                ></notification-content></div
            ></template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import NotificationPreview from './notification-preview.vue'
import NotificationContent from './notification-content.vue'
import EmptyState from './empty-state.vue'
import InboxSearch from './inbox-search.vue'

export default {
  components: {
    NotificationPreview,
    NotificationContent,
    EmptyState,
    InboxSearch,
  },

  props: {
    companyName: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters([
      'activeNotificationId',
      'notifications',
      'communicationItem',
      'loadingNotifications',
      'querySearch',
    ]),
  },

  created() {
    this.fetchNotifications()
    this.fetchMentionUsernames()

    // It is an event emmited by "edit-remark-modal", we have to refresh content of remark after update
    window.eventHub.$on(
      'refreshCommunicationData',
      this.refreshNotificationData
    )
  },

  beforeUnmount() {
    window.eventHub.$off(
      'refreshCommunicationData',
      this.refreshNotificationData
    )
  },

  methods: {
    ...mapActions([
      'fetchNotifications',
      'refreshNotificationData',
      'handleNotificationClick',
      'handleNotificationUnread',
      'fetchMentionUsernames',
      'handleCompanySearch',
    ]),
    handleClick(id) {
      this.handleNotificationClick(id)
    },
    handleMarkUnread(id) {
      this.handleNotificationUnread(id)
    },
    handleSearch(value) {
      this.handleCompanySearch(value)
    },
  },
}
</script>
